module.exports = __webpack_public_path__ + "media/shop.ab3a4380.mp4";